import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AboutContentCard from '../components/AboutContentCard';
import { Helmet } from 'react-helmet-async';

export default function About() {
  const [content, setContent] = useState([]);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const { data } = await axios.get('/api/about'); // Fetch from your backend
        setContent(data.sections || []); // Ensure data.sections is an array
      } catch (error) {
        console.error('Error fetching content:', error);
      }
    };
    fetchContent();
  }, []);

  return (
    <div className='content'>
      <Helmet>
        <title>About Us</title>
      </Helmet>
      <br />
      {content.length > 0 ? (
        content.map((section, index) => (
          <AboutContentCard
            key={index}
            section={section}
            imagePosition={index % 2 === 0 ? 'left' : 'right'} // Alternate image positions
          />
        ))
      ) : (
        <p>Loading content...</p>
      )}
      <br />
    </div>
  );
}
